import React from "react";
import OnInteractionModal from "./onInteractionModal/OnInteractionModal";
import OnScreenInstructions from "./OnScreenInstructions";
import torreLogo from "../assets/images/torreLogo.png";
import Crosshair from "./Crosshair";
import useOnInteractionModalStore from "./onInteractionModal/useOnInteractionModalStore";

const DesktopUI = () => {
  const {content} = useOnInteractionModalStore();

  return (
    <>
      <OnInteractionModal />

      <div className="absolute bottom-0 left-0 right-0 m-8 flex flex-row-reverse justify-between items-end">
        <img className="w-24" src={torreLogo} alt="logo" />

        {!content && <OnScreenInstructions />}
      </div>

      <Crosshair />
    </>
  );
};

export default DesktopUI;
